/*
 Controller used for the mobile initial lead guest screen
 */
/* global bookingApp, angular */
(function(){
    bookingApp.controller('confirmationController',function($scope, $sce, $http){
        'use strict';

        $scope.session.isLoading = true;
        $scope.session.bookingMade = true;

        // setup the footer controls
        $scope.footer.display.prev = false;
        $scope.footer.display.next = false;
        $scope.footer.display.main = true;
        $scope.footer.mainContent = 'New Booking';
        if ($scope.session.redirectWholesale) {
            $scope.footer.mainContent = 'Next Booking';
        }
        $scope.footer.mainFunc = function(){
            if ($scope.session.redirectWholesale) {
                window.location.href = '/front-booking/wholesale/' + $scope.session.redirectWholesale;
                return;
            }
            $scope.reloadApp();
        };

        if($scope.session.confirmClose){
            $scope.session.showConfirmCloser = true;
        }
    });
})();
